export default {
  /* eslint-disable no-param-reassign */
  /**
   * Set the object of CMS text to the state.
   * @param {Object} state - The module's state.
   * @param {Object} cmsText - The CMS Text object retrieved from the CMS API.
   */
  setText(state, { cmsText }) {
    state.text = { ...cmsText };
  },
  /* eslint-enable no-param-reassign */
};
